import React from 'react';

import { Container } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import AssetRelationsTable from 'components/AssetRelationsTable/AssetRelationsTable';
import AssetRelationsTabs from 'components/AssetRelationsTabs/AssetRelationsTabs';
import ManagePageHeader from 'components/ManagePageHeader/ManagePageHeader';
import Section from 'components/Section';
import TextButton from 'components/TextButton/TextButton';
import assets_messages from 'messages/assets_messages';
import { useHelpDialogContext } from 'reactContext/HelpDialogContext/HelpDialogContext';

const AssetRelationsPage: React.FC = () => {
  const { t } = useTranslation();
  const { showHelpDialog } = useHelpDialogContext();

  const openHelpDialog = () =>
    showHelpDialog({
      title: t(assets_messages.relations.help_title),
      body: t(assets_messages.relations.help_body),
    });

  return (
    <Container>
      <ManagePageHeader rightAdornment={<TextButton onClick={openHelpDialog}>{t(assets_messages.relations.help_link)}</TextButton>}>
        {t(assets_messages.page_header)}
      </ManagePageHeader>
      <AssetRelationsTabs />
      <Section smallPadding title={t(assets_messages.relations.title)} titleVariant='h3'>
        <AssetRelationsTable descriptionPreviewLength={85} />
      </Section>
    </Container>
  );
};

export default AssetRelationsPage;
